export default __webpack_public_path__ + "static/media/Image.2ab9328a.png";